import { lazy } from 'react';
import { ROUTES } from 'config/routes';

export const HomePage = lazy(() => import('features/home/HomePage'));
export const CatalogPage = lazy(() => import('features/catalog/CatalogPage'));
export const CategoryPage = lazy(() => import('features/catalog/CategoryPage'));
export const SubcategoryPage = lazy(() => import('features/catalog/SubcategoryPage'));
export const BrandPage = lazy(() => import('features/catalog/BrandPage'));
export const BrandsPage = lazy(() => import('features/catalog/BrandsPage'));
export const PromotionsPage = lazy(() => import('features/catalog/PromotionsPage'));
export const NewsPage = lazy(() => import('features/catalog/NewsPage'));
export const ProductDetailPage = lazy(() => import('features/catalog/ProductDetailPage'));
export const SearchResultsPage = lazy(() => import('features/search/SearchResultsPage'));
export const CartPage = lazy(() => import('features/cart/CartPage'));
export const CheckoutPage = lazy(() => import('features/checkout/CheckoutPage'));
export const OrderConfirmationPage = lazy(() => import('features/checkout/OrderConfirmationPage'));
export const OrderTrackingPage = lazy(() => import('features/orders/OrderTrackingPage'));
export const OrdersPage = lazy(() => import('features/orders/OrdersPage'));
export const LoginPage = lazy(() => import('features/account/LoginPage'));
export const RegisterPage = lazy(() => import('features/account/RegisterPage'));
export const ForgotPasswordPage = lazy(() => import('features/account/ForgotPasswordPage'));
export const ActivateAccountPage = lazy(() => import('features/account/ActivateAccountPage'));
export const B2bAccessRequestPage = lazy(() => import('features/account/B2bAccessRequestPage'));
export const AccountPage = lazy(() => import('features/account/AccountPage'));
export const ProfilePage = lazy(() => import('features/account/ProfilePage'));
export const AddressesPage = lazy(() => import('features/account/AddressesPage'));
export const FavoritesPage = lazy(() => import('features/account/FavoritesPage'));
export const HistoryPage = lazy(() => import('features/account/HistoryPage'));

export const AdminAuthCallbackPage = lazy(() => import('features/admin/AdminAuthCallbackPage'));
export const AdminLoginPage = lazy(() => import('features/admin/AdminLoginPage'));
export const AdminDashboardPage = lazy(() => import('features/admin/AdminDashboardPage'));
export const AppearancePage = lazy(() => import('features/admin/AppearancePage'));
export const CatalogSettingsPage = lazy(() => import('features/admin/CatalogSettingsPage'));
export const FeaturesPage = lazy(() => import('features/admin/FeaturesPage'));
export const LayoutPage = lazy(() => import('features/admin/LayoutPage'));
export const NavigationPage = lazy(() => import('features/admin/NavigationPage'));
export const StoreUnavailablePage = lazy(() => import('features/store/StoreUnavailablePage'));

export { ROUTES };
